import { type } from "./env";

const gameData = {
    "super-roulette": [
        { name: "STRAIGHT UP", min: 1, max: 0.1, multiplier: 35 },
        { name: "SPLIT", min: 1, max: 0.2, multiplier: 17 },
        { name: "STREET", min: 1, max: 0.3, multiplier: 11 },
        { name: "CORNER", min: 1, max: 0.4, multiplier: 8 },
        { name: "SIX LINE", min: 1, max: 0.6, multiplier: 5 },
        { name: "COLUMN", min: 1, max: 1, multiplier: 2 },
        { name: "DOZEN", min: 1, max: 1, multiplier: 2 },
        { name: "RED / BLACK", min: 1, max: 1, multiplier: 1 },
        { name: "EVEN / ODD", min: 1, max: 1, multiplier: 1 },
        { name: "1-18 / 19-36", min: 1, max: 1, multiplier: 1 }
    ],
    "azia-roulette": [
        { name: "STRAIGHT UP", min: 1, max: 0.2, multiplier: 35 },
        { name: "SPLIT", min: 1, max: 0.2, multiplier: 17 },
        { name: "STREET", min: 1, max: 0.2, multiplier: 11 },
        { name: "CORNER", min: 1, max: 0.2, multiplier: 8 },
        { name: "SIX LINE", min: 1, max: 0.2, multiplier: 5 },
        { name: "COLUMN", min: 1, max: 1, multiplier: 2 },
        { name: "DOZEN", min: 1, max: 1, multiplier: 2 },
        { name: "RED / BLACK", min: 1, max: 1, multiplier: 1 },
        { name: "EVEN / ODD", min: 1, max: 1, multiplier: 1 },
        { name: "1-18 / 19-36", min: 1, max: 1, multiplier: 1 }
    ]
}

const data = gameData[type]

const getBetType = (cellId) => {

    // colors
    if (cellId === "red" || cellId === "black") return "RED / BLACK";

    // even / odd
    if (cellId === "even" || cellId === "odd") return "EVEN / ODD";

    // ranges
    if (cellId === "1-18" || cellId === "19-36") return "1-18 / 19-36";

    // dozens
    if (/^(1st12|2nd12|3rd12)$/.test(cellId)) return "DOZEN";

    // columns
    if (/^2to1-(1|2|3)$/.test(cellId)) return "COLUMN";

    const parts = cellId.split("-");

    // numeric combinations
    const allNumeric = parts.every(x => /^\d+$/.test(x));

    if (allNumeric) {
        const count = parts.length;

        if (count === 2) return "SPLIT";
        if (count === 3) return "STREET";
        if (count === 4) return "CORNER";
        if (count === 6) return "SIX LINE";
    }

    if (/^\d+$/.test(cellId)) return "STRAIGHT UP";

    return null;
}

const getMaxLimit = (cellId, maxbet) => {
    const betType = getBetType(cellId)
    const row = data.find(p => p.name === betType);
    if (!row) return Infinity;
    return maxbet * row.max;
}

const getMinLimit = (cellId, minbet) => {
    const betType = getBetType(cellId)
    const row = data.find(p => p.name === betType);
    if (!row || row.min == null) return 0;
    return minbet * row.min;
}

const addWithLimit = ({ stakes, items, max }) => {
    const temp = [...stakes];
    const valid = [];

    items.forEach(({ cellId, addValue }) => {

        const i = temp.findIndex(s => s.cellId === cellId);
        const prev = i !== -1 ? temp[i].value : 0;

        const maxAllowed = getMaxLimit(cellId, max);

        const allowed = maxAllowed - prev;
        if (allowed <= 0) return;

        const finalAdd = Math.min(addValue, allowed);

        valid.push({ cellId, addValue: finalAdd });

        if (i === -1) {
            temp.push({ cellId, value: finalAdd });
        } else {
            temp[i].value += finalAdd;
        }
    });

    if (valid.length === 0) return null;

    return { stakes: temp, valid };
};


const addToList = (list, type, validItems) => {
    return [
        ...list,
        {
            type,
            items: validItems.map(i => ({
                cellId: i.cellId,
                addedValue: i.addValue
            }))
        }
    ];
};

export { data, getMaxLimit, getMinLimit, addWithLimit, addToList }
